import React, { FC, useMemo } from 'react'
import { ReactComponent as NexwaySvg } from '../../assets/svgs/Nexway.svg'
import { ReactComponent as ConnextSvg } from '../../assets/svgs/Connext.svg'
import { NxSvgName } from './types'

type NxSvgProps = {
  name: NxSvgName
  title?: string
} & React.SVGProps<SVGSVGElement>

const NAMES_TO_COMPONENTS: Record<
  NxSvgName,
  React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string
    }
  >
> = { 'Nexway': NexwaySvg, 'Connext': ConnextSvg }

const NxSvg: FC<NxSvgProps> = ({ name, ...restProps }): React.ReactElement => {
  return useMemo(() => {
    const Svg = NAMES_TO_COMPONENTS[name]
    return <Svg {...restProps} role='img' />
  }, [name, restProps])
}

export default NxSvg
